  (() => {
    // ✅ Pehle hi check karein
    if (window.innerWidth >= 991) return;

    let initialized = false;
    let rafId = null; // 👈 requestAnimationFrame ID

    function initAccordions() {
      const accordions = document.querySelectorAll(".footer-accordion");
      
      accordions.forEach((accordion) => {
        const items = accordion.querySelectorAll(":scope > .accordion-item");
        
        items.forEach((item) => {
          const header = item.querySelector(":scope > .accordion-header");
          const content = item.querySelector(":scope > .accordion-content");

          if (!header || !content || item.dataset.init) return;
          item.dataset.init = "true";

          // ✅ Height ko cache karein (baar-baar read na karein)
          let cachedHeaderHeight = header.offsetHeight;
          let cachedContentHeight = content.scrollHeight;
          let isOpen = false;

          // ✅ Optimized update (sirf tab read jab zaroorat ho)
          const updateHeight = (el, force = false) => {
            if (!force && !el.classList.contains("open")) return;
            
            // ✅ requestAnimationFrame use karein
            if (rafId) cancelAnimationFrame(rafId);
            rafId = requestAnimationFrame(() => {
              const head = el.querySelector(":scope > .accordion-header");
              const cont = el.querySelector(":scope > .accordion-content");
              if (!head || !cont) return;

              // ✅ Cached values use karein (jab tak content change na ho)
              if (el.classList.contains("open")) {
                const h = isOpen ? cachedHeaderHeight : head.offsetHeight;
                const c = isOpen ? cachedContentHeight : cont.scrollHeight;
                el.style.height = h + c + "px";
              } else {
                el.style.height = head.offsetHeight + "px";
              }

              // ✅ Parent update sirf tab jab zaroorat ho
              const parentItem = el.parentElement.closest(".accordion-item");
              if (parentItem && parentItem.classList.contains("open")) {
                updateHeight(parentItem);
              }
            });
          };

          // ✅ Click event optimized
          header.addEventListener("click", (e) => {
            e.preventDefault();

            const parentAccordion = item.parentElement;
            
            // ✅ Sirf open items ko close karein (saare par loop na karein)
            parentAccordion.querySelectorAll(":scope > .accordion-item.open").forEach((sib) => {
              if (sib !== item) {
                sib.classList.remove("open");
                const sibHeader = sib.querySelector(":scope > .accordion-header");
                if (sibHeader) {
                  sib.style.height = sibHeader.offsetHeight + "px";
                }
              }
            });

            // ✅ Toggle current
            isOpen = !isOpen;
            item.classList.toggle("open");
            
            // ✅ Cache values update karein (jab open ho)
            if (isOpen) {
              cachedHeaderHeight = header.offsetHeight;
              cachedContentHeight = content.scrollHeight;
            }
            
            updateHeight(item, true);
          });

          // ✅ Initial height set (without unnecessary reads)
          item.style.height = header.offsetHeight + "px";

          // ✅ ResizeObserver optimized (debounce ke saath)
          let resizeTimeout = null;
          const ro = new ResizeObserver(() => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
              if (item.classList.contains("open")) {
                cachedHeaderHeight = header.offsetHeight;
                cachedContentHeight = content.scrollHeight;
                updateHeight(item, true);
              }
            }, 100); // 👈 Debounce (100ms)
          });
          ro.observe(header);
          ro.observe(content);

          // ✅ Cleanup function (memory leak prevention)
          item._cleanup = () => {
            ro.disconnect();
            clearTimeout(resizeTimeout);
            if (rafId) cancelAnimationFrame(rafId);
          };
        });
      });
    }

    // ✅ Single trigger function (clean)
    function triggerInit() {
      if (initialized) return;
      initialized = true;

      initAccordions();

      // ✅ Saare listeners remove karein
      window.removeEventListener("scroll", triggerInit);
      window.removeEventListener("click", triggerInit);
      window.removeEventListener("touchstart", triggerInit);
      window.removeEventListener("DOMContentLoaded", triggerInit);
    }

    // ✅ Lazy triggers (only 1 main trigger)
    const events = ["scroll", "click", "touchstart", "DOMContentLoaded"];
    events.forEach((evt) => {
      window.addEventListener(evt, triggerInit, { passive: evt === "scroll" });
    });

    // ✅ Safety: Agar page pehle se loaded hai toh immediately run karein
    if (document.readyState === "complete" || document.readyState === "interactive") {
      // Thoda delay dein taake main content pehle render ho jaye
      setTimeout(triggerInit, 50);
    }

  })();